<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Operator Tariff</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Surcharge (Overrides)
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    Surcharges (Overrides) <span><i class="ic-price-calculator"></i></span>
                  </h2>
                  <p>Set surcharge for Operator Tariff.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option v-for="item in table.pageSizes" :value="item" :key="item">
                    {{ item }}
                  </option>
                </select>
                Entries
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Policy</th>
                  <th>Provider</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.policyTitle }}</td>
                  <td>{{ item.providerName }}</td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToManageGeneralSurcharge"
                        class="btn btn-default --green35"
                        type="button"
                        @click="manageGeneralSurcharge(item)"
                      >
                        <span>General</span>
                      </button>
                      <button
                        v-if="isAllowToManageCancellationSurcharge"
                        class="btn btn-default --green35"
                        type="button"
                        @click="manageCancellationSurcharge(item)"
                      >
                        <span>Cancellation</span>
                      </button>
                      <button
                        v-if="isAllowToManagePeakPeriodSurcharge"
                        class="btn btn-default --green35"
                        type="button"
                        @click="managePeakPeriodSurcharge(item)"
                      >
                        <span>Peak-Period</span>
                      </button>
                      <button
                        v-if="isAllowToManageWaitingTimeSurcharge"
                        class="btn btn-default --green35"
                        type="button"
                        @click="manageWaitingTimeSurcharge(item)"
                      >
                        <span>Waiting-Time</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <generalSurcharge v-if="isAllowToManageGeneralSurcharge" />
    <cancellationSurcharge v-if="isAllowToManageCancellationSurcharge" />
    <peakPeriodSurcharge v-if="isAllowToManagePeakPeriodSurcharge" />
    <waitingTimeSurcharge v-if="isAllowToManageWaitingTimeSurcharge" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import generalSurcharge from "@/components/master/buyingTariff/OverriddenGeneralSurcharge";
import cancellationSurcharge from "@/components/master/buyingTariff/OverriddenCancellationSurcharge";
import peakPeriodSurcharge from "@/components/master/buyingTariff/OverriddenPeakPeriodSurcharge";
import waitingTimeSurcharge from "@/components/master/buyingTariff/OverriddenWaitingTimeSurcharge";
import buyingTariffSurchargeService from "@/services/master/buyingTariff/buyingTariffOverriddenSurchargeService.js";

export default {
  components: {
    generalSurcharge,
    cancellationSurcharge,
    peakPeriodSurcharge,
    waitingTimeSurcharge,
  },
  computed: {
    isServicesExist: function () {
      return this.allServices && this.allServices !== null;
    },
    isAllowToRead: function () {
      return (
        this.isServicesExist &&
        (this.allServices["BuyingTariffOverriddenGeneralSurcharge"] ||
          this.allServices["BuyingTariffOverriddenCancellationSurcharge"] ||
          this.allServices["BuyingTariffOverriddenPeakPeriodSurcharge"] ||
          this.allServices["BuyingTariffOverriddenWaitingTimeSurcharge"])
      );
    },
    isAllowToManageGeneralSurcharge: function () {
      return (
        this.isServicesExist &&
        this.allServices["BuyingTariffOverriddenGeneralSurcharge"].includes("Read")
      );
    },
    isAllowToManageCancellationSurcharge: function () {
      return (
        this.isServicesExist &&
        this.allServices["BuyingTariffOverriddenCancellationSurcharge"].includes("Read")
      );
    },
    isAllowToManagePeakPeriodSurcharge: function () {
      return (
        this.isServicesExist &&
        this.allServices["BuyingTariffOverriddenPeakPeriodSurcharge"].includes("Read")
      );
    },
    isAllowToManageWaitingTimeSurcharge: function () {
      return (
        this.isServicesExist &&
        this.allServices["BuyingTariffOverriddenWaitingTimeSurcharge"].includes("Read")
      );
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      validationErrors: {},
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      allServices: null,
      items: [],
      isLoading: false,
      msg: "Please wait",
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(publicSettings, "PageSize", 25);

    const profile = await this.$store.dispatch("user/getProfile");
    this.allServices = profile.services;

    if (this.isAllowToRead) {
      await this.getAll();
    }
  },
  updated() {
    this.$helper.collapseMenu("buying-tariff");
    this.$helper.setNavigationClass("overridden-buying-surcharge-link");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async getAll() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await buyingTariffSurchargeService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    manageGeneralSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeBuyingTariffOverriddenGeneralSurcharge", item);
    },
    manageCancellationSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeBuyingTariffOverriddenCancellationSurcharge", item);
    },
    managePeakPeriodSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeBuyingTariffOverriddenPeakPeriodSurcharge", item);
    },
    manageWaitingTimeSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeBuyingTariffOverriddenWaitingTimeSurcharge", item);
    },
  },
};
</script>

<style scoped>
.detail-row td {
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/master/buyingTariff/OverriddenSurcharge.vue